(function () {
  'use strict';

  /* Toggle del acordeón (modo producto / PDP). Global porque el trigger lo
     invoca desde un onclick inline con el uid embebido por Liquid
     (`onclick="wcCotizToggle('{{ wc_uid }}')"`), igual que en el original. */
  window.wcCotizToggle = window.wcCotizToggle || function (sid) {
    var panel = document.getElementById('wc-cotiz-panel-' + sid);
    var trigger = document.querySelector('#wc-cotiz-' + sid + ' .wc-cotiz__trigger');
    if (!panel || !trigger) return;
    var isOpen = !panel.hidden;
    panel.hidden = isOpen;
    trigger.setAttribute('aria-expanded', String(!isOpen));
    trigger.classList.toggle('wc-cotiz__trigger--open', !isOpen);
  };

  /* Inicializa una instancia del formulario. `wrap` es el .wc-cotiz raíz;
     todo lo demás se busca dentro de su scope (nada de ids globales salvo
     los que ya requiere wcCotizToggle arriba). El snippet puede renderizarse
     más de una vez por página (PDP directo + wc-cotiza-cta), por eso el init
     recorre todas las instancias en vez de asumir una sola. */
  function initCotizForm(wrap) {
    var UID          = wrap.dataset.uid;
    var MODO         = wrap.dataset.modo;
    var MIDDLEWARE   = wrap.dataset.middlewareUrl;
    var ES_PRODUCTO  = MODO === 'producto';

    var form = wrap.querySelector('.wc-cotiz__form');
    if (!form) return;

    var panel       = wrap.querySelector('.wc-cotiz__panel');
    var errorEl     = wrap.querySelector('.wc-cotiz__error');
    var successEl   = wrap.querySelector('.wc-cotiz__success');
    var submitBtn   = wrap.querySelector('.wc-cotiz__submit');
    var submitLabel = submitBtn.textContent.trim();

    if (ES_PRODUCTO && typeof subscribe === 'function') {
      /* El SKU del panel se fija en el render con la primera variante
         disponible; si el cliente cambia de color, la cotización debe llevar el
         SKU de la variante que realmente seleccionó. constants.js/pubsub.js
         cargan con defer, por eso esto corre hasta DOMContentLoaded. */
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event.data.sectionId !== UID) return;
        var variant = event.data.variant;
        if (!variant || !variant.sku) return;
        panel.dataset.sku = variant.sku;
        var skuLabel = wrap.querySelector('[data-sku-label]');
        if (skuLabel) skuLabel.textContent = variant.sku;
      });
    }

    /* Modo general: toggle Particular / Mayoreo. Los campos de mayoreo llevan
       `hidden` (no solo display:none) para que no participen en la validación
       ni en el orden de tabulación cuando están ocultos. */
    var esMayoreo = false;
    var camposMayoreo = form.querySelectorAll('.wc-cotiz__field--mayoreo');

    if (!ES_PRODUCTO) {
      var audBtns = wrap.querySelectorAll('.wc-cotiz__audiencia-btn');
      Array.prototype.forEach.call(audBtns, function (btn) {
        btn.addEventListener('click', function () {
          esMayoreo = btn.dataset.aud === 'mayoreo';
          Array.prototype.forEach.call(audBtns, function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          Array.prototype.forEach.call(camposMayoreo, function (f) { f.hidden = !esMayoreo; });
        });
      });
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      var fd       = new FormData(form);
      var cantidad = parseInt(fd.get('cantidad'), 10);
      var email    = (fd.get('email') || '').trim();
      var empresa  = (fd.get('empresa') || '').trim();
      var mensaje  = (fd.get('mensaje') || '').trim();

      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
        errorEl.scrollIntoView({ block: 'nearest' });
      }

      if (!fd.get('contacto') || !email) {
        showError('Por favor completa los campos obligatorios.');
        return;
      }
      // El input es type="email" pero el form lleva novalidate; validamos el
      // formato aquí para no mandar leads incontactables al middleware.
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        showError('Escribe un correo electrónico válido (ej: correo@empresa.com).');
        return;
      }

      var payload = {
        contacto: fd.get('contacto'),
        email:    email,
        telefono: fd.get('telefono') || null,
        mensaje:  mensaje || null,
      };

      if (ES_PRODUCTO) {
        var sku = panel.dataset.sku;
        if (!empresa) { showError('Indica el nombre de tu empresa.'); return; }
        if (!cantidad || cantidad < 1) {
          showError('Indica una cantidad de piezas válida (mínimo 1).');
          return;
        }
        if (!sku) {
          showError('No pudimos identificar el producto. Recarga la página e intenta de nuevo.');
          return;
        }
        // `origen` explícito: si se dejara inferir y el SKU no resolviera, el
        // lead se archivaría como consulta general y perdería la liga al
        // producto en vez de fallar de forma visible.
        payload.origen          = 'producto';
        payload.sku             = sku;
        payload.producto_nombre = panel.dataset.product;
        payload.cantidad        = cantidad;
        payload.empresa         = empresa;
        payload.colores         = fd.get('colores') || null;
      } else {
        if (!mensaje) { showError('Cuéntanos brevemente qué necesitas.'); return; }
        if (esMayoreo && !empresa) { showError('Indica el nombre de tu empresa.'); return; }
        payload.origen   = 'general';
        payload.empresa  = esMayoreo ? (empresa || null) : null;
        payload.cantidad = (esMayoreo && cantidad >= 1) ? cantidad : null;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Enviando...';

      var GENERIC_ERR = 'No pudimos enviar tu solicitud. Intenta de nuevo o escríbenos por WhatsApp.';

      try {
        var res = await fetch(MIDDLEWARE + '/api/v1/public/cotizacion', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) {
          // FastAPI 422 devuelve detail como array de objetos; interpolarlo
          // directo mostraba "[object Object]" al usuario.
          var data = await res.json().catch(function () { return {}; });
          var msg = typeof data.detail === 'string' ? data.detail : GENERIC_ERR;
          throw new Error(msg);
        }
        form.hidden = true;
        var aud = wrap.querySelector('.wc-cotiz__audiencia');
        if (aud) aud.hidden = true;
        successEl.hidden = false;
        successEl.focus();
      } catch (err) {
        // Un fallo de red lanza TypeError ("Failed to fetch"): mensaje en español.
        var isNetwork = err instanceof TypeError;
        showError(isNetwork ? GENERIC_ERR : (err.message || GENERIC_ERR));
        submitBtn.disabled = false;
        submitBtn.textContent = submitLabel;
      }
    });
  }

  function init() {
    document.querySelectorAll('.wc-cotiz').forEach(initCotizForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
